import {Button, DialogBody, DialogFooter, DialogHeader, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {postValidateReservationDiscount} from "../../services/branch_discount/agent_branch_discount";
import {getPersonWalletBalance, getPersonWalletBalanceByPersonId} from "../../services/payment/payment";
import {ceil, parseInt} from "lodash";
import {postValidateBackOfficeReservationDiscount} from "../../services/back_office/discount";

export function InvoiceForm({
                              open,
                              setOpen,
                              onSave,
                              branchVatPercentage,
                              price,
                              branchId,
                              agentId,
                              chargeDiscountCode,
                              setStep,
                              setChargeAmount,
                              setChargeDiscountCode,
                              buttonLoading,
                              personId,
                            }) {

  const handleOpen = () => setOpen(!open);

  const [consultationPriceAfterDiscount, setConsultationPriceAfterDiscount] = useState(0);
  const [consultationVat, setConsultationVat] = useState(0);

  const [balance, setBalance] = useState(false);

  useEffect(() => {
    async function getWalletData(agentBranchFeeId) {
      let wallet_result;
      if (!personId) {
        wallet_result = await getPersonWalletBalance();
      } else {
        wallet_result = await getPersonWalletBalanceByPersonId(personId);
      }

      if (wallet_result.status === 200) {
        const {person_wallet_balance} = wallet_result.data;
        setBalance(person_wallet_balance ?? 0)
      }
    }

    getWalletData()

    if (chargeDiscountCode) {
      handleDiscountCode()
    }
  }, []);

  useEffect(() => {
    setConsultationPriceAfterDiscount(price);
    setConsultationVat(ceil(price * branchVatPercentage / 100))
    setTotalPrice(price + ceil(price * branchVatPercentage / 100));
  }, [price]);

  useEffect(() => {
    setConsultationVat(ceil(consultationPriceAfterDiscount * branchVatPercentage / 100));
  }, [consultationPriceAfterDiscount, branchVatPercentage]);

  const [totalPrice, setTotalPrice] = useState(price * (1 + branchVatPercentage / 100));

  useEffect(() => {
    setTotalPrice(consultationPriceAfterDiscount + consultationVat)
  }, [consultationVat]);

  const [discount, setDisCount] = useState(false)
  const [discountCode, setDisCountCode] = useState(chargeDiscountCode)
  const [finalDiscountCode, setFinalDiscountCode] = useState("")
  const [discountPercentage, setDisCountPercentage] = useState(null)
  const [discountValue, setDisCountValue] = useState(null);

  const getDiscountedPrice = (referencePrice, percentage, maxValue) => {
    const discount = Math.min(
      Math.floor(referencePrice * parseInt(percentage) / 100),
      parseInt(maxValue),
    );
    return referencePrice - discount;
  };

  async function handleDiscountCode() {

    const data = {
      branch_id: branchId,
      discount_code: discountCode,
      agent_id: agentId,
      price: price,
    }

    let result;
    if (!personId) {
      result = await postValidateReservationDiscount(data);
    } else {
      result = await postValidateBackOfficeReservationDiscount(data, personId);
    }
    if (result.status === 200) {
      const {discount_values} = result.data;
      setFinalDiscountCode(discountCode);
      setDisCountPercentage(discount_values && discount_values.percentage || 0);
      setDisCountValue(discount_values && discount_values.value || 0);
      if ((price * (parseInt(discount_values.percentage)) / 100) >= parseInt(discount_values.value)) {
        setConsultationPriceAfterDiscount(price - parseInt(discount_values.value));
      } else {
        setConsultationPriceAfterDiscount(getDiscountedPrice(price, discount_values.percentage, discount_values.value))
      }
      setDisCount(true)
    } else {
      setConsultationPriceAfterDiscount(price)
      setDisCount(false)
    }
  }

  const save = (tag) => {
    if (tag === 'return') {
      setStep(1)
    } else if (tag === 'payment') {
      if (consultationPriceAfterDiscount + consultationVat <= balance) {
        onSave(consultationPriceAfterDiscount, consultationVat, finalDiscountCode, tag, personId)
      } else if (consultationPriceAfterDiscount + consultationVat > balance) {
      }
    }
  };

  return (
    <>
      <DialogHeader className="bg-gray-800 rounded-2xl -mt-4">
        <Typography className="py-2 w-full text-white text-2xl z-10 textCenter">
          تکمیل خرید
        </Typography>
      </DialogHeader>


      <DialogBody className="flex flex-col gap-4 overflow-y-scroll">


        <div className="flex flex-row justify-between border-b-2 mb-2">
          <div className="flex flex-col">
            <Typography className="flex flex-col ml-2">
              {`${Dict('total_consultation_price')}: `}
            </Typography>
          </div>
          <div className="flex flex-col">
            <Typography className="flex flex-col" color="blue-gray">
              {`${persianNumberFormat(price, true)} ریال`}
            </Typography>
          </div>
        </div>

        <div className="relative flex flex-row mb-4 w-full mx-2">
          <Input variant="standard"
                 className="flex flex-col w-1/2"
                 value={discountCode}
                 label={Dict('discount_code')}
                 placeholder={Dict('discount_code')}
                 onChange={(e) => {
                   setDisCountCode(e.target.value);
                 }}
          />
          <Button variant="outlined" size="sm" color="gray" onClick={handleDiscountCode}
                  className="!absolute left-1 top-1 rounded text-center">
            اعمال کدتخفیف
          </Button>
        </div>

        {discount &&
          <>
            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('discount')}:`}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {`${persianNumberFormat(price - consultationPriceAfterDiscount, true)} ریال`}
                </Typography>
              </div>
            </div>

            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('after_discount')}:`}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {`${persianNumberFormat(consultationPriceAfterDiscount, true)} ریال`}
                </Typography>
              </div>
            </div>
          </>
        }

        <div className="flex flex-row justify-between border-b-2 mb-2">
          <div className="flex flex-col">
            <Typography className="flex flex-col ml-2">
              {persianNumberFormat(branchVatPercentage) + "% " + "ارزش افزوده: "}
            </Typography>
          </div>
          <div className="flex flex-col">
            <Typography className="flex flex-col" color="blue-gray">
              {`${persianNumberFormat(consultationVat, true)} ریال`}
            </Typography>
          </div>
        </div>

        <div className="flex flex-row justify-between border-b-2 mb-2">
          <div className="flex flex-col">
            <Typography className="flex flex-col ml-2">
              {`${Dict('total_price')}: `}
            </Typography>
          </div>
          <div className="flex flex-col">
            <Typography className="flex flex-col" color="blue-gray">
              {`${persianNumberFormat(totalPrice, true)} ریال`}
            </Typography>
          </div>
        </div>


      </DialogBody>

      <DialogFooter className="space-x-2 justify-between">
        <div className="flex flex-row right-0">
          <Typography className="flex flex-col">
            {Dict('balance') + ": "}
          </Typography>
          {balance === false &&
            <Typography className="flex flex-col" color="blue-gray">
              در حال دریافت ...
            </Typography>
          }
          {balance !== false &&
            <Typography className="flex flex-col mb-2" color="blue-gray">
              {persianNumberFormat(balance, true) + " ریال"}
            </Typography>
          }
        </div>
        <div className=" flex flex-row mt-4 left-0 md:mt-0">
          <Button variant="text" color="gray" onClick={() => {
            save('return')
          }}>
            <span>بازگشت</span>
          </Button>
          {consultationPriceAfterDiscount + consultationVat <= balance &&
            <Button variant="gradient" color="gray" disabled={buttonLoading} loading={buttonLoading} onClick={() => {
              save('payment')
            }} className="ml-1">
              <span>پرداخت از کیف پول</span>
            </Button>
          }
          {consultationPriceAfterDiscount + consultationVat > balance &&
            <Button variant="gradient" color="gray" size="sm md:lg" onClick={() => {
              setChargeAmount(totalPrice - balance)
              setChargeDiscountCode(discountCode)
              setStep(3)
            }} className="ml-1">
              <span>شارژ کیف پول</span>
            </Button>
          }
        </div>
      </DialogFooter>
    </>
  );
}
